import { useMutation, useQueryClient } from '@tanstack/react-query'
import type { ISpProfilePublic } from '@brushfire/types'
import { apiClient } from '@/api/http/client'
import type { ApiResponse } from '@/api/http/types'
import { queryKeys } from '@/api/query-keys'

export function useUploadSpAvatar() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (file: File) => {
      const form = new FormData()
      form.append('image', file)
      const { data } = await apiClient.post<ApiResponse<ISpProfilePublic>>(
        '/api/v1/sp/profile/avatar',
        form,
      )
      return data.data
    },
    onSuccess: (profile) => {
      qc.setQueryData(queryKeys.spProfile.detail(), profile)
    },
  })
}
